import { FormEvent, useState } from "react";
import { FilterActions } from "./FilterActions.tsx";

export type CheckboxListOption<Value extends string> = {
  value: Value;
  label: string;
};

export function CheckboxListFilter<Value extends string>({
  options,
  value,
  onApply,
  close,
}: {
  options: CheckboxListOption<Value>[];
  value: Value[];
  onApply: (selected: Value[]) => void;
  close: () => void;
}) {
  const [selected, setSelected] = useState<Value[]>(value);

  function toggle(optionValue: Value) {
    setSelected((current) =>
      current.includes(optionValue)
        ? current.filter((item) => item !== optionValue)
        : [...current, optionValue],
    );
  }

  function apply(nextSelected: Value[]) {
    onApply(nextSelected);
    close();
  }

  function applySelection(event: FormEvent) {
    event.preventDefault();
    apply(options.map((o) => o.value).filter((v) => selected.includes(v)));
  }

  return (
    <form onSubmit={applySelection} className="flex flex-col gap-1 px-2">
      {options.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 rounded-md px-1 py-1 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer"
        >
          <input
            type="checkbox"
            checked={selected.includes(option.value)}
            onChange={() => toggle(option.value)}
            className="h-4 w-4 accent-primary"
          />
          {option.label}
        </label>
      ))}
      <FilterActions canClear={value.length > 0} onClear={() => apply([])} />
    </form>
  );
}
